'use es6';

import { getIris } from 'pricing-pages-unified-ui/api/IrisApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchIrisRequestTypes = createRequestTypes('IRIS');
export const FetchIrisActions = createRequestActions(FetchIrisRequestTypes);
export const fetchIris = query => dispatch => {
  return makeFetchRequest({
    requestActions: FetchIrisActions,
    fetch: getIris,
    payload: query
  })(dispatch);
};